import { useMemo } from "react";

import { useUser } from "@components/user-context";

import { useInOnboarding } from "./use-in-onboarding";

type DropdownUser = {
  id: string;
  isAdmin: boolean;
  email: string;
  companyName: string | null;
};

export function useCompanyDropdownUsers(
  managedAccountsList?: DropdownUser[] | null,
): DropdownUser[] {
  const { user } = useUser();
  const { inOnboarding } = useInOnboarding();

  // NOTE: the "users" list from the backend, to accommodate some users
  // being companies and some just being users, returns only activated
  // users for this query. We need to populate this list with anything
  // returned from the "users" list (aka accounts in which im a manager)
  // as well as the account which I am the owner of if I am not on that
  // account currently.
  // The only way right now to (hackily) see if they have a company they want to start is
  // if they have saved a company name...
  const accessibleAccounts = useMemo(() => {
    const managedAccounts = managedAccountsList || [];
    const userHasInactiveCompany = user.authedUser.companyName && inOnboarding;
    if (
      managedAccounts.length > 1 ||
      (managedAccounts.length === 1 && userHasInactiveCompany)
    ) {
      const usersListToSet = userHasInactiveCompany
        ? [user.authedUser as DropdownUser, ...managedAccounts]
        : managedAccounts;
      return usersListToSet;
    }

    return [];
  }, [inOnboarding, managedAccountsList, user.authedUser]);

  return accessibleAccounts;
}
